import { connect } from 'react-redux';
import { modelGet } from '../../../actions/model.actions';
import Page from '../../../components/pages/core/alert/Alert.page.jsx';
import {
    AlertContainerCore,
    mapStateToPropsCore,
    mapDispatchToPropsCore
} from 'pluton-core/lib/containers/pages/core/Alert.container'


class AlertContainer extends AlertContainerCore {
    render() {
        return (
            <Page {...this.props}
                date={this._getCurrentDate()}
                isLoading={this.state.isLoading}
                handleDateChange={this.handleDateChange}

                handleGetNext={this.handleGetNext }
                handleGetPrev={this.handleGetPrev}

                showImportant={this.state.showImportant}
                handleToggleShowImportant={this.handleToggleShowImportant}

                alertsToggled={this.state.alertsToggled}
                handleAlertsToggle={this.handleAlertsToggle}
            />
        );
    }
}


export default connect(mapStateToPropsCore, mapDispatchToPropsCore(modelGet))(AlertContainer);



// WEBPACK FOOTER //
// ./app/containers/pages/core/Alert.container.jsx